import React from "react";
import { Container, Row, Col } from "shards-react";

import FileUpload from "../components/rawFileUpload/FileUpload";

class RawFileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <FileUpload
             projectId={this.props.match.params.id}
             />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default RawFileUpload;
